import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Typography, Button, Icon } from '@tucar/pit-stop';
import TopNav2 from '../../../components/ui/TopNav/newTopNav';

const SupportScreen = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ position: 'relative', paddingBottom: '80px' }}>
      <TopNav2 title="Soporte" />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
          padding: '0px 30px',
        }}
      >
        <Typography color="#5B5D71">
          ¿Tienes alguna duda o necesitas ayuda? Aquí te dejamos algunas opciones para que puedas
          contactarnos o encontrar respuestas a tus preguntas.
        </Typography>
        <Button
          fullWidth
          size="large"
          endAdornment={
            <Box sx={{ transform: 'rotate(180deg)' }}>
              <Icon name="leftArrowSpecial" size="16px" color="#A8AABA" />
            </Box>
          }
          onClick={() => navigate('/app/v2/faq', { replace: true })}
        >
          Preguntas Frecuentes
        </Button>
        <Typography color="#5B5D71">
          ¿Prefieres una atención virtual por videollamada? Agenda tu cita a continuación.
        </Typography>
        <Button
          fullWidth
          size="large"
          endAdornment={
            <Box sx={{ transform: 'rotate(180deg)' }}>
              <Icon name="leftArrowSpecial" size="16px" color="#A8AABA" />
            </Box>
          }
          onClick={() => window.open('https://calendar.app.google/uRr5HmCHFoUV2jrY7', '_blank')}
        >
          Agenda virtual
        </Button>
        <Typography color="#5B5D71">
          ¿Quieres venir a nuestra oficina de forma presencial? Puedes agendar tu hora haciendo
          click en el siguiente botón.
        </Typography>
        <Button
          fullWidth
          size="large"
          endAdornment={
            <Box sx={{ transform: 'rotate(180deg)' }}>
              <Icon name="leftArrowSpecial" size="16px" color="#A8AABA" />
            </Box>
          }
          onClick={() => window.open('https://calendar.app.google/XGi46vfariQfb2PXA', '_blank')}
        >
          Agenda Presencial
        </Button>
        <Typography color="#5B5D71">
          ¿Quieres contactarnos directamente? Contáctanos a través del chat.
        </Typography>

        <Button
          fullWidth
          size="large"
          endAdornment={
            <Box sx={{ transform: 'rotate(180deg)' }}>
              <Icon name="leftArrowSpecial" size="16px" color="#A8AABA" />
            </Box>
          }
          onClick={() => navigate('/app/v2/support/cases', { replace: true })}
        >
          Habla con nosotros
        </Button>
      </Box>
    </Box>
  );
};

export default SupportScreen;
